import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js';

function ChangePassword() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(true);
  const [showNewPassword, setShowNewPassword] = useState(true);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(true);
  const resource = 'change-password';

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

    function sha256(input) {
        return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
    }

    function md5(input) {
        return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
    }

    let hashedOldPassword = md5(oldPassword);
    hashedOldPassword = sha256(hashedOldPassword);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (window.confirm("Are you sure you want to change your password?")) {
      const formData = {
        oldPassword: hashedOldPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
        token: token
      };

      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/change-password",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Basic eGNwOk50dGkyMDI0IQ==",
            },
            body: JSON.stringify(formData),
          }
        );

        const data = await response.json();
        const responseBody = JSON.parse(data.body);
        if (!response.ok) {
          setError(data.message || "Failed to submit form");
          throw new Error(data.message || "Failed to submit form");
        }

        const { message } = responseBody;
        const statusCode = data.statusCode;
        if (message == "success") {

          // Store the token in local storage
          localStorage.setItem("token", token);

          window.alert("Your password has been changed");
          navigate("/order-list");
        } else if (statusCode != 200){
          setError(responseBody.message || 'Network response was not ok.');
        } 
      } catch (error) {
        console.error("Submission Error:", error.message);
        setError("Submission Error: " + error.message);
      }
    }
  };

  const toggleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };

  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleShowConfirmNewPassword = () => {
    setShowConfirmNewPassword(!showConfirmNewPassword);
  };

  return (
    <div className="container-order-input">
      <h1>Cross Connect Change Password</h1>
      <form onSubmit={handleSubmit}>
        <div className="order-information-order-input">
        </div>
        <div className="box-two-part">
          <div className="part-change-password">
            <div className="textbox-cp" style={{ position: "relative", display: "inline-block" }}>
              <label htmlFor="oldPassword">Old Password</label>
              <input
                type={!showOldPassword ? "text" : "password"}
                placeholder="Old Password"
                onChange={(e) => setOldPassword(e.target.value)}
                style={{ paddingRight: "150px" }}
                required
              />
              <span
                    onClick={toggleShowOldPassword}
                    style={{
                    position: "absolute",
                    right: "-95px",
                    top: "75%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    }}
                >
                    <i className={showOldPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </span>
            </div>
            <div className="textbox-cp" style={{ position: "relative", display: "inline-block" }}>
              <label htmlFor="newPassword">New Password</label>
                <input
                    type={!showNewPassword ? "text" : "password"}
                    placeholder="New Password"
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                    style={{ paddingRight: "150px" }} 
                />
                <span
                    onClick={toggleShowNewPassword}
                    style={{
                    position: "absolute",
                    right: "-95px",
                    top: "75%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    }}
                >
                    <i className={showNewPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </span>
            </div>
            <div className="textbox-cp" style={{ position: "relative", display: "inline-block" }}>
              <label htmlFor="confirmNewPassword">Confirm New Password</label>
              <input
                    type={!showConfirmNewPassword ? "text" : "password"}
                    placeholder="Confirm New Password"
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    required
                    style={{ paddingRight: "150px" }} 
                />
                <span
                    onClick={toggleShowConfirmNewPassword}
                    style={{
                    position: "absolute",
                    right: "-95px",
                    top: "75%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    }}
                >
                    <i className={showConfirmNewPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </span>
            </div>
            <div className="password-requirements">
              <p>Password requirements:</p>
              <p>1. Password length between 6 to 20 characters</p>
              <p>2. Password contains combination between upper case and lower case character</p>
              <p>3. Password contains at least 1 number</p>
              <p>4. Password contains at least 1 special character</p>
            </div>
            {error && <p className="error-message">{error}</p>}
            <input
            type="submit"
            className="btn-submit-change-password"
            value="Change Password"
            />
          </div>        
        </div>
      </form>
    </div>
  );
}

export default ChangePassword;
